/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */

/**
 * Represents the presented granularity of energy usage; to what level the energy usage values are aggregated to.
 */
export type EnergyUsageGranularity =
  (typeof EnergyUsageGranularity)[keyof typeof EnergyUsageGranularity]

export const EnergyUsageGranularity = {
  HH: "HH",
  DAY: "DAY",
  WEEK: "WEEK",
  MONTH: "MONTH",
  YEAR: "YEAR",
} as const
